module.exports = __webpack_public_path__ + "static/kellson-956f53907a36895d11e23ece422df051.png";